import { environment } from './../../environments/environment';
import { JwtDto } from '../models/jwt-dto';
import { Observable } from 'rxjs';
import { LoginUsuario } from 'src/app/models/login-usuario';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AlertController } from '@ionic/angular';
import { mergeMap, tap } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  banderaLogin = false;

  constructor(private httpClient: HttpClient, private alertController: AlertController) { }
  public login(loginUsuario: LoginUsuario): Observable<JwtDto> {
    // Petición de inicio de sesion incluyendo el id del dispotivo
    return this.httpClient.post<JwtDto>(environment.global + 'auth/login', loginUsuario).pipe(
      mergeMap(response => {
        // Respuesta para debug
        if (!environment.production) {
          console.log('Login exitoso.');
        }

        // Se recibio respuesta y es disntinta de error
        this.banderaLogin = true;

        // Verificar que en la rspuesta el club sea igual al del environment
        if (
          (response.club.toString() === '2' && environment.club.toString() === 'alpha') ||
          (response.club.toString() === '3' && environment.club.toString() === 'alpha') ||
          (response.club.toString() === '5' && environment.club.toString() === 'cimera') ||
          (response.club.toString() === '4' && environment.club.toString() === 'sports') ||
          (response.club.toString() === '23' && environment.club.toString() === 'cenit') ||
          (response.club.toString() === '31' && environment.club.toString() === 'cimeragym') // 
        ) {
          this.alertaExito();
          if (response.activo.toString() === 'false') {
            // Mostrar alerta de cuenta en cobranza
            this.alertaCuentaEnCobranza();
            return throwError(() => new Error('Cuenta en cobranza.'));
          }
          return [response];
        } else {
          // Mostrar alerta de error y no permitir el inicio de sesion
          this.alertaClubNoAutorizado();
          return throwError(() => new Error('Club no autorizado para esta aplicación.'));
        }

      }),
      catchError((error) => {
        if (error.status === 400) {
          // Error de contraseña incorrecta
          this.alertaPassword();
          return throwError(() => error);
        } else if (error.status === 0 && !this.banderaLogin) {
          // Error de conexión
          this.alerta();
          return throwError(() => error);
        }
        return throwError(() => error);
      })
    );
  }
  // Alertas de inicio de sesion
  async alerta(): Promise<void> {
    const alert = await this.alertController.create({
      header: 'Intenta nuevamente',
      message: 'No fue posible autenticarte en este momento.',
      buttons: [
        {
          text: 'Aceptar',
          role: 'cancel',
          handler: () => {
            // No hace nada
          }
        }
      ]
    });
    await alert.present();
    const { role } = await alert.onDidDismiss();
  }

  async alertaPassword(): Promise<void> {
    const alert = await this.alertController.create({
      header: 'Intenta nuevamente',
      message: 'La contraseña o el usuario es incorrecto.',
      buttons: [
        {
          text: 'Aceptar',
          role: 'cancel',
          handler: () => {
            // No hace nada
          }
        }
      ]
    });
    await alert.present();
    const { role } = await alert.onDidDismiss();
  }


  async alertaExito(): Promise<void> {
    const alert = await this.alertController.create({
      header: 'Bienvenido',
      message: 'Has iniciado sesion correctamente.',
      animated: true
    });
    await alert.present();

    setTimeout(() => {
      alert.dismiss();
    }, 2000);
  }


  // Alerta de club no autorizado
  async alertaClubNoAutorizado(): Promise<void> {
    const alert = await this.alertController.create({
      header: 'Acceso denegado',
      message: 'No puedes ingresar a este club.',
      buttons: [
        {
          text: 'Aceptar',
          role: 'cancel',
          handler: () => {
            // No hace nada
          }
        }
      ]
    });
    await alert.present();
  }


  // Alerta de cuenta en cobranza
  async alertaCuentaEnCobranza(): Promise<void> {
    const alert = await this.alertController.create({
      header: 'Cuenta en cobranza',
      message: 'Tu cuenta está en cobranza. Por favor, contacta a tu club para más información.',
      buttons: [
        {
          text: 'Aceptar',
          role: 'cancel',
          handler: () => {
            // No hace nada
          }
        }
      ]
    });
    await alert.present();
  }
}
